import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DsButtonBorderColors, DsButtonVariants, Icons, IconStyles } from '@levelaccess/design-system';

@Component({
  selector: 'app-common-name-tag',
  templateUrl: './common-name-tag.component.html',
  styleUrls: ['./common-name-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommonNameTagComponent {
  public readonly DsButtonBorderColors: typeof DsButtonBorderColors = DsButtonBorderColors;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly Icons: typeof Icons = Icons;
  public readonly IconStyles: typeof IconStyles = IconStyles;

  @Input()
  public fileName: string;

  @Input()
  public redBorder: boolean;

  @Output()
  public closeButtonClicked: EventEmitter<void>;

  constructor() {
    this.closeButtonClicked = new EventEmitter<void>();
  }

  public buttonClicked(): void {
    this.closeButtonClicked.emit();
  }
}
